import ServiceBase from "../../servicebase";

export default class CnetService extends ServiceBase {
  reloaddata = () : Promise<boolean> => 
    this.GetFetch('reloaddata', {});
}
